<template>
	<li class="stats__item">
		<div class="stats__title"><span>Дата:</span>
			{{ inkey }}
			<div class="razd"></div>
			<span class="db">Общее время занятий:</span>{{ dayTime(item) }}
		</div>
		<ul class="stats__subitems">
			<li class="stats__subitem" v-for="si in item" :key="si.id">

				<!--ТРЕНАЖЕР-->
				<div class="stats__part">
					<span>Тип задания:</span>
					{{ (si && si.trainer) ? si.trainer.title : ''}}
					<small v-if="si.is_homework"><br>Домашнее задание</small>
				</div>

				<!--ВРЕМЯ ВЫПОЛНЕНИЯ-->
				<div class="stats__part">
					<span>Время выполнения:</span>
					<i v-if="si.time">
						{{ si.time.minutes }} минут {{ si.time.seconds }} секунд
					</i>
					<i v-else>
						{{ sumTime(si.exercises)}}
					</i>
				</div>

				<!--НАСТРОЙКИ У ЦИФРОВЫХ-->
				<div class="stats__part">
					<span>Параметры:</span>
					<div class="stats__row" v-if="typeof si.params.direct !== 'undefined'">
						<span>Направление:</span> {{ si.params.direct ? 'Прямое' : 'Обратное' }}
					</div>
					<div class="stats__row" v-if="si.params.size">
						<span>Размер поля:</span> {{ si.params.size }}x{{ si.params.size }}
					</div>
					<div class="stats__row" v-if="si.params.mode">
						<span>Режим:</span> {{ si.params.mode === 'train' ? 'Тренировка' : 'Испытания' }}
					</div>
					<div class="stats__row" v-if="si.params.type">
						<span>Тип:</span> {{ si.params.type === 'multi' ? 'Умножение' : 'Деление' }}
					</div>
					<div class="stats__row" v-if="typeof si.params.direction !== 'undefined'">
						<span>Направление:</span> {{ si.params.direction ? 'Число -> Абакус' : 'Абакус -> Число' }}
					</div>
					<div class="stats__row" v-if="typeof si.params.formula !== 'undefined'">
						<span>Формула:</span>
						<i v-if="si.params.formula == '0'">Прямой счет</i>
						<i v-else-if="si.params.formula == '5'">Формулы 5-ки</i>
						<i v-else-if="si.params.formula == '10'">Формулы 10-ки</i>
						<i v-else-if="si.params.formula == '10-5'">Формулы 5-ки и 10-ки</i>
						<i v-else-if="si.params.formula == '15'">Комбинации</i>
						<i v-else-if="si.params.formula == '*'">Микс</i>
					</div>

					<div class="stats__row" v-if="typeof si.params.terms !== 'undefined'">
						<span>Слагаемых:</span> {{ si.params.terms }}
					</div>

					<div class="stats__row" v-if="typeof si.params.rank !== 'undefined'">
						<span>Числа:</span> от {{ split(si.params.rank, '/')[0] }} до {{ split(si.params.rank, '/')[1] }}
					</div>

					<div class="stats__row" v-if="typeof si.params.first !== 'undefined'">
						<span>Разряды:</span> {{ si.params.first }}, {{ si.params.second }}
					</div>

					<div class="stats__row" v-if="si.params.speed">
						<span>Скорость:</span>
						<i v-if="si.trainer_id !== 5">{{ si.params.speed }}</i>
						<i v-else-if="si.trainer_id === 5">{{ si.params.mode !== 'train' ? si.params.speed : 'Нет'  }}</i>
					</div>
				</div>


				<div class="stats__part">
					<span>Результат:</span>

					<div class="stats__row">
						<span>Примеров:</span>
						{{ si.count ? si.count : 1 }}
					</div>

					<div class="stats__row">
						<span>Ошибок:</span>
						{{ si.errors }}
					</div>

					<div class="stats__row" v-if="[1,2,4].indexOf(si.trainer_id) === -1">
						<span>Верно выполнено:</span>
						{{ (si.count ? si.count : 1) - si.errors }} из {{ si.count ? si.count : 1 }}
					</div>

					<!--ПРОЦЕНТ ВЫПОЛНЕНИЯ ДЛЯ МНЕМОТЕХНИКИ -->
					<div class="stats__row" v-if="[4].indexOf(si.trainer_id) !== -1">
						<span>Процент верных:</span>
						{{ 100 - Math.round((si.errors/(si.params.size*si.params.size))*100) }}%
					</div>
					<!--ПРОЦЕНТ ВЫПОЛНЕНИЯ ДЛЯ МНЕМОТЕХНИКИ -->
					<div class="stats__row" v-if="[3,5,6,8].indexOf(si.trainer_id) !== -1">
						<span>Процент верных:</span>
						{{ perc(si.errors, (si.count ? si.count : 1)) }}%
					</div>

					<div class="stats__row">
						<span>Баллов начислено:</span>
						{{ si.scores }}
					</div>

				</div>

			</li>
		</ul>
	</li>
</template>

<script>
  import moment from "moment";

  export default {
    name: "stat_item",
    data() {
      return {}
    },
    props: {
      item: '',
      inkey: ''
    },
    methods: {
      /** Split */
      split(str, razd){
        return str.split(razd);
      },
      /** Процент выполнения */
      perc(n1, n2) {
        return 100 - Math.round((n1 / n2) * 100);
      },
      /** Общее время работы на тренажере за день */
      dayTime(day) {
        //console.log('Daytime', day);
        let allTime = _.reduce(day, function (sum, n) {
          return sum + ((n && n.time_ms) ? n.time_ms : 0);
        }, 0);
        let dur = moment.utc(moment.duration(allTime).asMilliseconds()).format("HH:mm:ss");
        return dur;
      },
      /** Подсчет времени */
      sumTime(arr) {
        let allTime = _.reduce(arr, function (sum, n) {
          return sum + (n.timer.total_ms ? n.timer.total_ms : 0);
        }, 0);
        let dur = moment.utc(moment.duration(allTime).asMilliseconds()).format("HH:mm:ss");
        return dur;
      }
    }
  }
</script>